import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { CanonicalService } from '../../../shared/seo/canonical.service';

@Component({
  selector: 'app-software-development',
  imports: [CommonModule,RouterLink],
  templateUrl: './software-development.component.html',
  styleUrl: './software-development.component.scss',
  encapsulation: ViewEncapsulation.None 
})
export class SoftwareDevelopmentComponent implements OnInit {

  constructor(private titleService: Title, private metaService: Meta,private canonicalService: CanonicalService) {}

  ngOnInit(): void {
    // Set page title (50-60 characters ideally)
    this.titleService.setTitle('Software Development | Custom IT Solutions by MALtech');

    // Meta description (150-160 characters)
    this.metaService.updateTag({
      name: 'description',
      content: 'MALtech is your trusted partner for web, mobile, and enterprise software solutions. We focus on scalability, security, and user experience.'
    });

    // Robots meta tag
    this.metaService.updateTag({ name: 'robots', content: 'index, follow' });

   this.canonicalService.setCanonicalURL('service/software-development/');

  }

  cards2 = [
    { icon: 'assets/images/development/tech1.webp', title: 'Aws' },
    { icon: 'assets/images/development/tech2.webp', title: 'Devops' },
    { icon: 'assets/images/development/tech3.webp', title: 'PHP' },
    { icon: 'assets/images/development/tech4.webp', title: 'Flutter' },
    { icon: 'assets/images/development/tech5.webp', title: 'Python' },
    { icon: 'assets/images/development/tech6.webp', title: 'dotnet' },
    { icon: 'assets/images/development/tech7.webp', title: 'SQL' },
    { icon: 'assets/images/development/tech8.webp', title: 'WordPress' },
    { icon: 'assets/images/development/tech9.webp', title: 'Java' },
    { icon: 'assets/images/development/tech10.webp', title: 'Angualr' },
  ];

  cards3 = [
    {
      icon: 'bi bi-search',
      title: 'Requirement Analysis',
      description: 'We collaborate with clients to understand needs, gather requirements, and define clear project goals that align with business objectives.'
    },
    {
      icon: 'bi bi-pencil',
      title: 'Design & Prototyping',
      description: 'Our team creates UI/UX designs, wireframes, and interactive prototypes that bring your vision to life before development starts.'
    },
    {
      icon: 'bi bi-tv',
      title: 'Development',
      description: 'Using agile methodologies and modern frameworks, we build scalable, secure, and future-ready applications.'
    },
    {
      icon: 'bi bi-shield-check',
      title: 'Testing & Quality Assurance',
      description: 'Rigorous functional, performance, and security testing ensure your solution is reliable, bug-free, and business-ready.'
    },
    {
      icon: 'bi bi-rocket-takeoff',
      title: 'Deployment',
      description: 'We deliver seamless deployment with CI/CD pipelines, ensuring smooth transitions from staging to production.'
    },
    {
      icon: 'bi bi-arrow-repeat',
      title: 'Ongoing Support & Maintenance',
      description: 'Continuous monitoring, updates, and optimization keep your software performing at its best for long-term success.'
    }
  ];

  getStart() {
    const plansSection = document.getElementById('get-start');
    if (plansSection) {
      plansSection.scrollIntoView({ behavior: 'smooth' });
    }
  }

  cards4 = [
    {
      icon: 'assets/images/development/sec41.webp',
      title: 'Proven Expertise',
      description: 'Decades of combined experience in software development, cloud, and AI. Delivering scalable, secure solutions for global clients.'
    },
    {
      icon: 'assets/images/development/sec42.webp',
      title: 'End-to-End Solutions',
      description: 'From consultation to deployment and support, we manage the entire technology lifecycle under one roof.'
    },
    {
      icon: 'assets/images/development/sec43.webp',
      title: 'Future-Ready Innovation',
      description: 'We leverage AI, ML, and next-gen security to ensure your solutions remain future-proof and competitive.'
    },
    {
      icon: 'assets/images/development/sec44.webp',
      title: 'People-Centric Approach',
      description: 'Our agile processes, transparent communication, and client-first strategies put your success at the center.'
    }
  ];
}
